import React from "react";

export default function AdvancedFilter({ filters, setFilters }) {
  return (
    <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
      <select
        value={filters.type}
        onChange={e => setFilters(f => ({ ...f, type: e.target.value }))}
        style={{ padding: 8 }}
      >
        <option value="">All Types</option>
        <option value="audio">Audio</option>
        <option value="video">Video</option>
        <option value="lyric">Lyric</option>
      </select>
      <select
        value={filters.show}
        onChange={e => setFilters(f => ({ ...f, show: e.target.value }))}
        style={{ padding: 8 }}
      >
        <option value="">Show/Hide</option>
        <option value="true">Show</option>
        <option value="false">Hide</option>
      </select>
      <input
        placeholder="Artist"
        value={filters.artist}
        onChange={e => setFilters(f => ({ ...f, artist: e.target.value }))}
        style={{ padding: 8, width: 120 }}
      />
      <input
        type="date"
        value={filters.date}
        onChange={e => setFilters(f => ({ ...f, date: e.target.value }))}
        style={{ padding: 8 }}
      />
    </div>
  );
}